(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './LearnMore', './Social', './Support', './Copyright', '../footer-translations', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./LearnMore'), require('./Social'), require('./Support'), require('./Copyright'), require('../footer-translations'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.LearnMore, global.Social, global.Support, global.Copyright, global.footerTranslations, global.propTypes);
    global.Footer = mod.exports;
  }
})(this, function (exports, _react, _LearnMore, _Social, _Support, _Copyright, _footerTranslations, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _LearnMore2 = _interopRequireDefault(_LearnMore);

  var _Social2 = _interopRequireDefault(_Social);

  var _Support2 = _interopRequireDefault(_Support);

  var _Copyright2 = _interopRequireDefault(_Copyright);

  var _footerTranslations2 = _interopRequireDefault(_footerTranslations);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer(props) {
      _classCallCheck(this, Footer);

      var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

      _this.state = {
        isMobile: false
      };

      _this.throttleResize = _this.resize.bind(_this);
      return _this;
    }

    _createClass(Footer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this.throttleResize);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.throttleResize);
      }
    }, {
      key: 'renderLearnMore',
      value: function renderLearnMore(data) {
        return _react2.default.createElement(_LearnMore2.default, {
          logoAlt: data.learnMore.logo.alt,
          logoSrc: data.learnMore.logo.src,
          text: data.learnMore.text,
          learnHref: data.learnMore.learn.href,
          learnText: data.learnMore.learn.text,
          textStyles: { padding: '24px 0 20px 0' }
        });
      }
    }, {
      key: 'renderLearnExtra',
      value: function renderLearnExtra(learnExtra) {
        return _react2.default.createElement(_LearnMore2.default, {
          text: learnExtra.text ? learnExtra.text : '',
          learnHref: learnExtra.href ? learnExtra.href : '',
          learnText: learnExtra.hrefText ? learnExtra.hrefText : '',
          textStyles: { padding: '0 0 0 0' }
        });
      }
    }, {
      key: 'resize',
      value: function resize() {
        var _this2 = this;

        clearTimeout(this.resizeReady);
        this.resizeReady = setTimeout(function () {
          _this2.setState({
            isMobile: window.innerWidth < 768
          });
        }, 50);
      }
    }, {
      key: 'render',
      value: function render() {
        // Drupal Footer data is inconsistent, fallback to translations if attribute from drupal menu does not exist
        var data = Object.assign(_footerTranslations2.default[this.props.lang], this.props.drupalData) || _footerTranslations2.default[this.props.lang] || _footerTranslations2.default['en-us'];

        return _react2.default.createElement(
          'div',
          {
            className: 'www-footer-com',
            style: {
              backgroundColor: '#000'
            }
          },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(_Social2.default, {
                list: data.footerSocial
              }),
              _react2.default.createElement(_Support2.default, {
                links: data.footerSupport,
                selector: _footerTranslations2.default.selector,
                selectorText: data.support.selector,
                modelTitle: data.support.modelTitle,
                isMobile: this.state.isMobile
              }),
              _react2.default.createElement(_Copyright2.default, {
                text: data.copyright.text,
                links: data.footerCopy
              })
            )
          )
        );
      }
    }]);

    return Footer;
  }(_react2.default.Component);

  exports.default = Footer;
  ;

  Footer.propTypes = {
    lang: _propTypes2.default.string,
    drupalData: _propTypes2.default.object
  };

  Footer.defaultProps = {
    lang: 'en-us'
  };
});